// @flow
export const GET_PRODUCTS = 'hive/products/GET_PRODUCTS';
export const RECEIVE_PRODUCTS = 'hive/products/RECEIVE_PRODUCTS';
export const PRODUCT_MODE_CHANGE = 'hive/product/mode_change';
export const PRODUCT_MODE_CHANGE_UPDATE_PRODUCT = 'hive/product/mode_change/UPDATE_PRODUCT';
export const MODIFY_PRODUCT_STATE = 'hive/product/modify-state';
export const UNDO_PRODUCT_CHANGE = 'hive/products/undo-product-change';
export const RENAME_PRODUCT = 'hive/products/RENAME';
export const RENAME_PRODUCT_ZONE = 'hive/products/RENAME_ZONE';
export const REMOVE_PRODUCT = 'hive/products/REMOVE';
export const REMOVE_PRODUCT_ZONE = 'hive/products/REMOVE_ZONE';

export const MALFORMED_NODE_DESCRIPTOR = 'MALFORMED_NODE_DESCRIPTOR';



// WEBPACK FOOTER //
// ./src/core/state/products/constants.js